import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';

const EventBanner = () => {
    const { conferenceId } = useParams();
    const [bannerUrl, setBannerUrl] = useState('');
    const [conferenceTitle, setConferenceTitle] = useState('');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const fetchBannerAndTitle = async () => {
            try {
                setLoading(true);
                setError('');

                const bannerApiUrl = `https://eventscons.com/eventbackendnew/api/conference-banner-get/${conferenceId}`;
                const titleApiUrl = `https://eventscons.com/eventbackendnew/api/con/id/${conferenceId}`;

                const [bannerRes, titleRes] = await Promise.all([
                    fetch(bannerApiUrl),
                    fetch(titleApiUrl)
                ]);

                const bannerData = await bannerRes.json();
                const titleData = await titleRes.json();

                console.log('conferenceId:', conferenceId);
                console.log('bannerData:', bannerData);
                console.log('titleData:', titleData);

                if (bannerData?.status && bannerData?.data?.banner_url) {
                    setBannerUrl(bannerData.data.banner_url);
                }

                const apiTitle =
                    titleData?.data?.title ||
                    titleData?.conference?.title ||
                    titleData?.title ||
                    '';

                if (apiTitle) {
                    setConferenceTitle(apiTitle);
                } else {
                    setConferenceTitle('Conference Title Not Found');
                }

                if (!titleRes.ok) {
                    setError(titleData?.message || 'Conference title load nahi hua');
                }
            } catch (err) {
                setError('Error to load banner');
                console.error('API Error:', err);
            } finally {
                setLoading(false);
            }
        };

        if (conferenceId) {
            fetchBannerAndTitle();
        }
    }, [conferenceId]);

    const sectionStyle = {
        position: 'relative',
        padding: '220px 0 80px',
        backgroundImage: bannerUrl ? `url(${bannerUrl})` : `url('/images/bg-event.jpg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center right',
        display: 'flex',
        alignItems: 'center',
        minHeight: '440px',
        color: '#ffffff'
    };

    const overlayStyle = {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        background: 'linear-gradient(90deg, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.3) 50%, rgba(0,0,0,0.1) 100%)',
        zIndex: 1
    };

    const contentStyle = {
        position: 'relative',
        zIndex: 2,
        textAlign: 'left'
    };

    if (loading) {
        return (
            <section style={{ ...sectionStyle, backgroundImage: `url('/images/bg-event.jpg')` }}>
                <div style={overlayStyle}></div>
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div style={contentStyle}>
                                <h1>Loading banner...</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }

    return (
        <section style={sectionStyle}>
            <div style={overlayStyle}></div>
            <div className="container" style={{margin:'auto'}}>
                <div className="row">
                    <div className="col-md-12">
                        <div style={contentStyle}>
                            <h1 style={{
                                fontSize: '48px',
                                fontWeight: '800',
                                marginBottom: '15px',
                                background: '#9b1321',
    padding: '20px',
    borderRadius: '10px',
    lineHeight: '60px'
                            }}>
                                {conferenceTitle || 'Eventsconsultant Conference'}
                            </h1>

                            <nav style={{ fontSize: '18px', fontWeight: '500' }}>
                                <Link to="/" style={{ color: '#fff', textDecoration: 'none' }}>Home</Link>
                                <span style={{ margin: '0 10px', color: '#fff' }}>›</span>
                                <Link to="/events" style={{ color: '#fff', textDecoration: 'none' }}>Events</Link>
                                <span style={{ margin: '0 10px', color: '#fff' }}>›</span>
                                <span style={{ color: '#fff' }}>
                                    {conferenceTitle || 'Eventsconsultant Conference'}
                                </span>
                            </nav>

                            {error && (
                                <p style={{ marginTop: '10px', color: '#ffb3b3' }}>{error}</p>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default EventBanner;